import React, { useEffect, useState } from "react";
import ChildPic from "../../../../assets/images/child.jpg";
import { useHistory, useLocation } from "react-router-dom";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";
import useCrypto from "../../../customHooks/crypto";
import useKidListFunctionality from "../../../customHooks/kidListHook";
import moment from "moment";
import useLangTranslation from "../../../customHooks/languageProvider";

const LocateNow = () => {
  const history = useHistory();
  const location = useLocation();
  const { decryptRequest } = useCrypto();
  const { getImage } = useKidListFunctionality();
  const { getLangTranslation } = useLangTranslation();
  const MAP_KEY = decryptRequest(process.env.REACT_APP_GOOGLE_MAP_KEY);

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: MAP_KEY,
    libraries: ["places"],
  });
  if (!isLoaded) {
    return "Loading";
  }

  const center = {
    lat:
      Number(location?.state?.data?.selectedLocation?.latitude) || 10.99835602, // Ensure lat is a valid number, fallback to 0
    lng:
      Number(location?.state?.data?.selectedLocation?.longitude) || 77.01502627, // Ensure lng is a valid number, fallback to 0
  };

  return (
    <>
      <div className="card mb-6">
        <div className="card-body">
          <div className="d-flex align-items-center justify-content-between flex-wrap gap-6">
            <div className="list-item">
              <div className="list-content">
                <div className="d-inline-flex align-items-center lh-1">
                  <div
                    onClick={() => history.goBack()}
                    className="text-blue-900 fs-5"
                    style={{ cursor: "pointer" }}
                  >
                    <i className="icon-arrow-left" />
                  </div>
                  <h3 className="text-blue-900 mb-0">
                    {" "}
                    {getLangTranslation(
                      "CHILD_LOCATION_LOCATE_NOW",
                      "Locate now"
                    )}
                  </h3>
                </div>
              </div>
            </div>
            <div
              className="d-inline-flex  align-items-center pt-cursor"
              onClick={() => history.push("/location-history")}
            >
              <span className="icon-wrap icon-blue me-2 flex-shrink-0">
                <i className="icon-history" />
              </span>
              <h6 className="mb-0">
                {getLangTranslation("LOCATION_HISTORY", "Location History")}
              </h6>
            </div>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-body">
          <div style={{ width: "100%", height: "51vh" }} className="mb-6">
            <GoogleMap
              center={center}
              zoom={15}
              mapContainerStyle={{ width: "100%", height: "100%" }}
              options={{
                zoomControl: true,
                streetViewControl: false,
                mapTypeControl: true,
                fullscreenControl: true,
              }}
            >
              <Marker position={center} />
            </GoogleMap>
          </div>
          <button
            className="btn btn-primary mb-9"
            onClick={() => history.goBack()}
          >
            <span className="btn-upper-case">
              {getLangTranslation("CHILD_LOCATE_GOT_IT", "Got It")}
            </span>
          </button>
          <div className="d-flex align-items-center mb-3">
            <span className="icon-wrap icon-rounded me-2 p-0 overflow-hidden ratio ratio-1x1 border-0">
              <img
                src={
                  getImage(
                    location?.state?.data?.kidData?.image,
                    location?.state?.data?.kidData?.gender
                  ) || ChildPic
                }
                className="rounded-circle"
                alt=""
              />
            </span>
            <div>
              <h5 className="d-flex align-items-center text-blue-900 mb-0">
                <span className="badge rounded-pill d-inline-block badge-sm bg-success me-1"></span>{" "}
                {location?.state?.data?.kidData?.childName}
              </h5>
              <p className="mb-0 text-small ">
                {getLangTranslation("SETUP_WIZARD_DEVICE", "Device")}:{" "}
                {location?.state?.data?.kidDevice?.Name}
              </p>
            </div>
          </div>
          <p className="text-dark mb-0">
            {location?.state?.data?.selectedLocation?.locationAddress}
          </p>
          <span className="text-dark">
            {moment(
              location?.state?.data?.kidDevice?.selectedLocation?.locationTime
            ).format("DD- MMM- YYYY | hh:mm a")}
          </span>
        </div>
      </div>
    </>
  );
};

export default LocateNow;
